export enum ApiVersion {
  V1 = 'v1',
  V2 = 'v2',
  LEGACY_V2 = 'legacy_v2',
}
